import { useDispatch } from 'react-redux';
import { IonIcon, IonItem, IonToggle, IonNote, IonLabel } from '@ionic/react';
import { helpCircle } from 'ionicons/icons';

import { getValue } from 'helpers/events';
import ProjectSettingsActions from 'actions/ProjectSettingsActions';

import useHelpAlert from 'hooks/useHelpAlert';

export default function({value, onValueChange, property, label, help, note}) {
  const dispatch = useDispatch();
  const showHelp = useHelpAlert({title: label, ...(_.isPlainObject(help) ? help : {content: help})});
  const toggleLabel = help ? (
    <span className="clickable" onClick={help && showHelp}>
      {label} <IonIcon icon={helpCircle}/>
    </span>
  ) : label;

  const onChange = (checked) => dispatch(ProjectSettingsActions.set({[property]: checked}));
  const onIonChange = getValue(onValueChange || onChange);

  return (
    <IonItem>
      <IonToggle checked={value} onClick={onIonChange}>
        <IonLabel>{toggleLabel}</IonLabel>
        {note && <IonNote color="medium" className="ion-text-wrap">{note}</IonNote>}
      </IonToggle>
    </IonItem>
  );
}
